import React, { useMemo } from "react";

import SearchImage from "../images/Search.png";

const TRANSACTION_TYPES = [
  { key: "total_payment", label: "Total Payment" },
  { key: "eligible_payment", label: "Eligible Payment" },
  { key: "mobile_recharge", label: "Mobile Recharge" },
  { key: "make_payment", label: "Make Payment" },
  { key: "bill_pay", label: "Bill Pay" },
  { key: "cash_out", label: "Cash Out" },
];

const RecentTransactionSummary = ({
  transactionData,
  loading = false,
  error = false,
  errorMessage = "",
}) => {
  const months = useMemo(
    () => transactionData?.map((item) => item.month) || [],
    [transactionData]
  );

  const rows = useMemo(
    () =>
      TRANSACTION_TYPES.map((type) => ({
        label: type.label,
        values: transactionData?.map((item) => item[type.key] || 0) || [],
      })),
    [transactionData]
  );

  if (loading) {
    return (
      <div className="card-section transaction-summary">
        <h3 className="card-section__title">
          Last 6 months transaction summary
        </h3>
        <div className="table-container">
          <table className="transaction-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Transaction Types</th>
                {[...Array(6)].map((_, index) => (
                  <th key={index}>
                    <div className="skeleton skeleton-text skeleton-text--small"></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(6)].map((_, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}.</td>
                  <td className="type-cell">
                    <div className="skeleton skeleton-text skeleton-text--medium"></div>
                  </td>
                  {[...Array(6)].map((_, i) => (
                    <td key={i}>
                      <div className="skeleton skeleton-text skeleton-text--small"></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card-section transaction-summary">
        <h3 className="card-section__title">
          Last 6 months transaction summary
        </h3>
        <div className="error-state">
          <img src={SearchImage} alt="Error" className="error-image" />
          <h4 className="error-title">Error Fetching Data</h4>
          <p className="error-message">{errorMessage}</p>
        </div>
      </div>
    );
  }

  if (!transactionData || transactionData.length === 0) {
    return (
      <div className="card-section transaction-summary">
        <h3 className="card-section__title">
          Last 6 months transaction summary
        </h3>
        <div className="error-state">
          <img src={SearchImage} alt="Error" className="error-image" />
          <h4 className="error-title">No Data Available</h4>
        </div>
      </div>
    );
  }

  return (
    <div className="card-section transaction-summary">
      <h3 className="card-section__title">Last 6 months transaction summary</h3>
      <div className="table-container">
        <table className="transaction-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Transaction Types</th>
              {months.map((month) => (
                <th key={month}>{month}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={row.label}>
                <td>{idx + 1}.</td>
                <td className="type-cell">{row.label}</td>
                {row.values.map((val, i) => (
                  <td key={i}>{val.toLocaleString()}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentTransactionSummary;
